import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { APIService } from "../api/api.service";
import { KPI } from "../api/models";

@Injectable()
export class MaintenanceService {
  constructor(private apiService: APIService) {}

  public createAssetMaintenance(payload: KPI.AssetMaintenanceCreatePayload): Observable<KPI.AssetMaintenance> {
    return this.apiService.create_asset_maintenance(payload);
  }

  public updateAssetMaintenance(
    id: number,
    payload: KPI.AssetMaintenanceUpdatePayload
  ): Observable<KPI.AssetMaintenance> {
    return this.apiService.patch_asset_maintenance(id, payload);
  }

  public patchAssetMaintenance(
    id: number,
    payload: Partial<KPI.AssetMaintenanceUpdatePayload>
  ): Observable<KPI.AssetMaintenance> {
    return this.apiService.patch_asset_maintenance(id, payload);
  }

  public mapFormToPayload(formValues: any, assetId: number): KPI.AssetMaintenanceCreatePayload {
    return {
      asset: assetId,
      has_contract: formValues.maintenance_contract === "" 
        ? null 
        : formValues.maintenance_contract === "true",
      company: formValues.maintenance_company || "",
      contract_deadline: formValues.maintenance_contract_end_date || null,
      level: formValues.maintenance_level ? parseInt(formValues.maintenance_level) : null,
      responsibility: formValues.maintenance_responsible || "",
      manufacturer_control_frequency: formValues.manufacturer_control_frequency || "",
      control_frequency: formValues.manufacturer_control_frequency || "", 
      last_control_date: formValues.last_maintainer_control_date || null,
      equipment_evaluation: formValues.maintenance_evaluation || "",
      last_evaluation: formValues.maintenance_evaluation || "", 
      evaluated_by: "", 
      evaluation_date: new Date().toISOString().split("T")[0], 
      attached_to_equipment: true, 
      comment: formValues.maintenance_comment || ""
    };
  }

  public mapFormToUpdatePayload(formValues: any, assetId: number): KPI.AssetMaintenanceUpdatePayload {
    return this.mapFormToPayload(formValues, assetId) as KPI.AssetMaintenanceUpdatePayload;
  }
}
